export const toolbar = [
  [{header: '1'}, {header: '2'}, {header: [3, 4, 5, 6]}, {font: []}],
  [{size: []}],
  ['bold', 'italic', 'underline', 'strike', 'blockquote'],
  [{list: 'ordered'}, {list: 'bullet'}],
  ['image', 'video']
]
